import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/departmetns/settings/patient-info/get/REQUEST';
export const SUCCESS = '@app/departmetns/settings/patient-info/get/SUCCESS';
export const FAILURE = '@app/departmetns/settings/patient-info/get/FAILURE';

export const CLEAR = '@app/departmetns/settings/patient-info/data/CLEAR';

export const UPDATE_REQUEST = '@app/departmetns/settings/patient-info/put/REQUEST';
export const UPDATE_SUCCESS = '@app/departmetns/settings/patient-info/put/SUCCESS';
export const UPDATE_FAILURE = '@app/departmetns/settings/patient-info/put/FAILURE';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: '',
    data: {}
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.error = '';
                break;
            case SUCCESS:
                draft.loading = false;
                draft.data = payload;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.error = '';
                draft.data = {};
                draft.loading = false;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    update: (data) => creator(UPDATE_REQUEST, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *get({ payload }) {
        try {
            const response = yield axios.get(`/companies/patients-information/${payload}`);
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    },

    *put({ payload }) {
        try {
            const response = yield axios.put(
                `/companies/patients-information/${payload.company_id}`,
                payload
            );
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.get);
    yield takeLatest(UPDATE_REQUEST, sagas.put);
};
